import React from "react";

import Logo from "../images/logo2.png";
import { CiMail } from "react-icons/ci";
import { CiPhone } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";

const Contact = () => {
  return (
    <div className="w-full h-full   ">
      <div className="w-full lg:h-[90dvh]  flex items-center justify-center md:h-[120dvh] h-[140dvh]">
        <div className=" lg:w-[90%] w-full h-full gap-10 flex lg:flex-row md:flex-col flex-col items-center justify-center">
          <div className="lg:w-[45%] md:w-[75%] w-[90%] h-[80dvh] retreat rounded-2xl"></div>
          <div className="lg:w-[45%] md:w-[75%] w-[90%] h-[80dvh]  flex items-center justify-center rounded-3xl">
            <div className="w-[90%]  flex flex-col items-center lg:items-start md:items-start border border-black rounded-3xl lg:px-10 md:px-9 px-5 lg:py-8 md:py-10 py-6">
              <div className="w-16 ">
                <img src={Logo} alt="" className="w-full" />
              </div>
              <div className="flex flex-col  lg:items-start md:items-start items-center lg:py-5 md:py-5 py-3 lg:mb-10 md:mb-10 mb-5 ">
                <p className="font-light lg:text-[30px] md:text-[40px] text-[20px] leading-none lg:mb-3 mb-3 ">
                 Get In Touch
                </p>
                <p className="font-light font-worksans text-[15px] lg:text-[20px] md:text-[25px] ">
                </p>
              </div>

              <div className="w-full border border-black lg:mb-9 md:mb-10 mb-3"></div>

              <div className="w-full flex flex-col lg:items-start md:items-start items-start  ">
                <a
                  href="#"
                  className="font-light font-worksans lg:text-[20px] md:text-[28px] text-[18px] "
                >
                  {" "}
                  <CiMail size={20} /> jasminpanag75@gmail.com{" "}
                </a>
                <a
                  href="tel:(519)-774-6044"
                  className="font-light font-worksans lg:text-[20px] md:text-[28px] text-[18px] "
                >
                  {" "}
                  <CiPhone size={20} /> (519)-774-6044{" "}
                </a>
                <a
                  href="#"
                  className="font-light font-worksans lg:text-[20px] md:text-[28px] text-[18px] "
                >
                  {" "}
                  <CiLocationOn size={20} /> Brantford Ontario, Canada{" "}
                </a>
              </div>

              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
